import React, { useState } from 'react'
import Hero from '../components/Hero'
import DonationCTA from '../components/DonationCTA'

export default function SeParte() {
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const form = e.currentTarget
    const formData = new FormData(form)
    
    // Convert FormData to a regular object
    const data = {
      nombre: formData.get('nombre') as string,
      apellidos: formData.get('apellidos') as string,
      area_servicio: formData.get('area_servicio') as string,
      disponibilidad: formData.get('disponibilidad') as string,
      fecha_incorporacion: formData.get('fecha_incorporacion') as string,
      correo: formData.get('correo') as string,
      telefono: formData.get('telefono') as string,
      motivo: formData.get('motivo') as string,
    }
    
    try {
      const response = await fetch('/api/send-participation-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      
      if (response.ok) {
        setSubmitted(true)
      } else {
        const errorData = await response.json()
        console.error('Error:', errorData)
        alert('Hubo un error al enviar el formulario. Por favor, intenta de nuevo.')
      }
    } catch (error) {
      console.error('Error:', error)
      alert('Hubo un error al enviar el formulario. Por favor, intenta de nuevo.')
    }
  }

  return (
    <article className="min-h-screen">
      <div className="relative z-10">
        <Hero 
          title="Sé parte de La Gaviota IAP"
          subtitle="Únete como voluntario o colaborador y haz la diferencia"
          backgroundImage="/images/banners/huerto_v2_gaviota.jpg"
        />
      </div>
      <div className="w-screen flex justify-center mb-0">
        <div className="w-full max-w-7xl px-8 mt-32 mb-12 flex flex-col md:flex-row justify-between gap-20">
          <div className="md:basis-1/3 flex-[0_0_40%]">
            <h2 className="headline-xl mb-12 text-left">Realiza tu servicio social con nosotros</h2>
            <p className="body mb-4 text-left"><b>La Gaviota IAP</b> siempre está abierta no sólo a recibir ayuda, si no también a brindarla, incluso en el ámbito de desarrollo laboral, es por ello que abre sus puertas a todos los alumnos de quieran realizar su servicio social y las áreas estén relacionados con los servicios de <b>La Gaviota IAP</b>.</p>
            <p className="body mb-4 text-left">Actualmente se reciben alumnos que provienen de las siguientes Instituciones: <b>UPN, UNIVERSIDAD CENTRO, TEC DE MONTERREY, ESCUELA NORMAL DE ESPECIALIZACIÓN, IBERO, UVM, UNITEC</b> para que puedan realizar su servicio social.</p>
            <p className="body text-left">A partir de ello la Institución no solo contribuye a la sociedad en éste aspecto, sino que también gracias a éstos jóvenes innovadores,  se han obtenido beneficios para completar actividades a nivel operativo e incluso a obtener recursos materiales y tecnológicos.</p>
          </div>
          <div className="flex-1 max-w-xl">
            <section className="mb-16 flex flex-col items-center">
              <h2 className="headline-medium mb-8">Formulario de participación</h2>
              <div className="w-full">
                {submitted ? (
                  <div className="text-center py-8">
                    <h3 className="headline-small mb-4">¡Gracias por tu interés!</h3>
                    <p className="body text-gray-600">Nos pondremos en contacto contigo pronto.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-1">Nombre *</label>
                        <input type="text" name="nombre" id="nombre" required placeholder="Nombre" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent" />
                      </div>
                      <div>
                        <label htmlFor="apellidos" className="block text-sm font-medium text-gray-700 mb-1">Apellidos *</label>
                        <input type="text" name="apellidos" id="apellidos" required placeholder="Apellidos" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent" />
                      </div>
                    </div>
                    <div>
                      <label htmlFor="area_servicio" className="block text-sm font-medium text-gray-700 mb-1">Área de servicio social de tu interés *</label>
                      <input type="text" name="area_servicio" id="area_servicio" required placeholder="e.g Rehabilitación & Educación" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent" />
                    </div>
                    <div>
                      <label htmlFor="disponibilidad" className="block text-sm font-medium text-gray-700 mb-1">Disponibilidad de tiempo *</label>
                      <input type="text" name="disponibilidad" id="disponibilidad" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent" placeholder="X horas al día o semana" />
                    </div>
                    <div>
                      <label htmlFor="fecha_incorporacion" className="block text-sm font-medium text-gray-700 mb-1">Fecha que te interesa incorporarte al equipo *</label>
                      <input type="text" name="fecha_incorporacion" id="fecha_incorporacion" required placeholder="e.g 13 de Mayo, 2025" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent" />
                    </div>
                    <div>
                      <label htmlFor="correo" className="block text-sm font-medium text-gray-700 mb-1">Correo *</label>
                      <input type="email" name="correo" id="correo" required placeholder="e.g tu@correo.com" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent" />
                    </div>
                    <div>
                      <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-1">Teléfono *</label>
                      <input type="tel" name="telefono" id="telefono" required placeholder="e.g 56 3791 7120" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent" />
                    </div>
                    <div>
                      <label htmlFor="motivo" className="block text-sm font-medium text-gray-700 mb-1">¿Por qué te interesa hacer tu servicio con nosotros?</label>
                      <textarea name="motivo" id="motivo" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent" />
                    </div>
                    <button type="submit" className="w-full bg-[#FF5900] text-white py-3 px-6 rounded-full hover:bg-black transition-colors duration-300">Enviar</button>
                  </form>
                )}
              </div>
            </section>
          </div>
        </div>
      </div>
      <div className="mb-32">
        <DonationCTA />
      </div>
    </article>
  )
} 